import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function BlogDetails() {
    const { t, i18n } = useTranslation();
    const { id } = useParams();
    const [blog, setBlog] = useState(null);

    useEffect(() => {
        fetch(`https://ligasos-laravel.ligasos.co/api/blogs/${id}`)
            .then((response) => response.json())
            .then((data) => setBlog(data))
            .catch((error) => console.error("Error fetching blog details:", error));
    }, [id]);

    const isArabic = i18n.language === "ar";

    if (!blog) {
        return <div>{t("Blog not found.")}</div>;
    }

    return (
        <>
            <section className="blog-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div>
                        <div className="font-bold text-white text-[40px] capitalize">
                            {t("Blog Details")}
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[40px]">
                    <div className="flex flex-col gap-[3px]">
                        <div className="text-[30px] font-bold text-[#0B2C3D]">
                            {t(isArabic ? blog.title_ar : blog.title_en)}
                        </div>
                        <img
                            className="h-[3px]"
                            src={require("../../assets/icons/line-text.svg").default}
                            alt=""
                        />
                    </div>
                    <div className="flex flex-col gap-[20px]">
                        <img
                            className="w-full h-[360px] object-cover rounded-[8px]"
                            src={`https://ligasos-laravel.ligasos.co/storage/app/public/${blog.image}`}
                            alt={`blog-${blog.id}`}
                        />
                        <div>{t(isArabic ? blog.details_ar : blog.details_en)}</div>
                    </div>
                </div>
            </section>
        </>
    );
}